// Klient PROXY + helper BLE do uzyskania key (FFA1/FFA2)
import {
  DEBUG_MODE,
  getUrlECGExtInfo,
  getUrlECGReport,
  getUrlECGUploadRecord,
} from '../../spdConfig';
import { Loader } from '../loader';
import * as Configuration from '../testConfiguration';

type ExtInfoResp = {
  file_report?: string;
  file_url?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ext?: any; // interpretacja; czasem już jest obiektem
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
};

export enum ExamECGType {
  Arrhythmia = 1, /// Conventional ECG for 30 seconds,
  Unknow = 2, /// Do testów
  Ischemia = 3, /// Myocardial ischemia for 10 seconds at each location, directly spliced together
  HeartLoad = 5, ///Type =5: Heart load for more than 2
}

// ------------------------------------------------------------
//  ProxyClient
// ------------------------------------------------------------
export class ECGProxyClient {
  public static async uploadECGRecord(
    blobRecord: Blob,
    key: string,
    examType: ExamECGType,
    surveyNumber: string | null,
    gender: Configuration.Gender,
    birthday: Date,
  ) {
    try {
      const fd = new FormData();
      fd.append('file', blobRecord, 'ecg.dat');

      const patient = {
        first_name: 'SPD: ',
        second_name: surveyNumber || 'TEST',
        sex: gender === Configuration.Gender.Male ? 2 : 1,
        birthday: birthday.toISOString(),
        language_id: 1002,
      };
      fd.append('patient', JSON.stringify(patient));

      const record = {
        test_time: Math.floor(Date.now() / 1000),
        type: examType, // kod badania
        device_type: 5, // kod urządzenia
        key: key,
      };
      DEBUG_MODE && console.log('uploadECGRecord', patient, record);
      fd.append('record', JSON.stringify(record));

      const ret = await Loader.postSync(
        getUrlECGUploadRecord(),
        fd,
        true,
        true,
      );
      return ret.id;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public static async getExtInfo(rid: number) {
    try {
      const json = await Loader.getSyncJSONWithVersion(
        getUrlECGExtInfo(),
        { rid: String(rid) },
        true,
      );
      return json as ExtInfoResp;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  public static async getReportPdfBlob(params: { rid?: number; url?: string }) {
    // zbuduj parametry zapytania
    const data =
      params.url !== null
        ? { url: params.url }
        : params.rid !== null
        ? { rid: String(params.rid) }
        : null;

    try {
      const blob = await Loader.getSyncBlobWithVersion(
        getUrlECGReport(),
        data,
        true,
      );
      return blob;
    } catch (e) {
      console.error(e);
      return null;
    }
  }
}
